import { FC } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";

import { VortexButton } from "components/Button";
import { GradientButton } from "components/GradientButton";

interface DisabledCardProps {
  onClick?: () => void;
}

export const DisabledCard: FC<DisabledCardProps> = ({ children, onClick }) => {
  return (
    <div className={styles.root}>
      <GradientButton
        onClick={onClick}
        className={styles.btnViewMore}
        size="large"
      >
        View more
      </GradientButton>
      <div className={clsx(styles.disabledCard, "no-select")}>{children}</div>
    </div>
  );
};
